<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :dhp-extension="dhpExtension"
            :date-units="dateUnits"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/DhpExtensions/Form.vue'

const props = defineProps({
    dhpExtension: {
        type: Object,
        default: () => {
            return {}
        }
    },
    dateUnits: {
        type: Array,
        default: () => {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.put(route('settings.dhp-extensions.update', { dhp_extension: props.dhpExtension.id }))
}
</script>
